function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.125 9c-1.087 0-1.969-.895-1.969-2 0-1.11.886-2 1.969-2 1.093 0 1.969.89 1.969 2 0 1.105-.882 2-1.969 2zm0 5c-1.087 0-1.969-.895-1.969-2 0-1.11.886-2 1.969-2 1.093 0 1.969.89 1.969 2 0 1.105-.882 2-1.969 2zm0 5c-1.087 0-1.969-.895-1.969-2 0-1.11.886-2 1.969-2 1.093 0 1.969.89 1.969 2 0 1.105-.882 2-1.969 2zM20 10h-2.953V8.86C18.74 8.41 20 6.86 20 5h-2.953V4c0-.552-.44-1-.985-1H8.188a.992.992 0 00-.984 1v1H4.25c0 1.86 1.26 3.41 2.953 3.86V10H4.25c0 1.86 1.26 3.41 2.953 3.86V15H4.25c0 1.86 1.26 3.41 2.953 3.86V20c0 .552.44 1 .984 1h7.876a.992.992 0 00.984-1v-1.14C18.74 18.41 20 16.86 20 15h-2.953v-1.14C18.74 13.41 20 11.86 20 10z",
  fill: "currentColor"
});

function SvgTrafficLight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficLight);
export default __webpack_public_path__ + "static/media/traffic-light.7073950ce34aded1a47e46080217f7b9.svg";
export { ForwardRef as ReactComponent };